import navigationComponent from './navigation.component';

const navigationModule = angular.module('navigation', [
])
  .component('navigation', navigationComponent)
  .name;

export default navigationModule;
